<template>
     <vs-dialog v-model="active" prevent-close width="700px">
        <template #header>
          <h4 class="not-margin">
            Editar <b>Sesión</b>
          </h4>
        </template>
        <div class="center content-inputs">
            <vs-alert warn v-if="rowData && rowData.registros_academicos_a_desvincular && rowData.registros_academicos_a_desvincular != 0">
                <template #title>
                    Esta sesión cuenta con alumnos vinculados.
                </template>
            </vs-alert>
            <vs-row class="mt-3">
                <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="4" >
                   
                    <label for="edificios" class="pl-3 mr-1">Edificios</label>
                    <vs-select id="edificios" filter placeholder="Edificios" v-model="edificio" :disabled="!listEdificios.length" @input="listarAulas" class="pt-0">
                        <template #message-danger v-if="errorFields.includes('edificio')">
                            Requerido
                        </template>
                        <template v-if="listEdificios.length">
                            <vs-option v-for="option in listEdificios" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>

                    <label for="docente" class="pl-3 mr-1">Docente Auxiliar</label>
                     <vs-select id="docente" filter placeholder="Docente Auxiliar" v-model="docenteAuxiliar" :disabled="!listDocentes.length" class="pt-0">
                        <template v-if="listDocentes.length">
                            <vs-option v-for="option in listDocentes" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                        
                    </vs-select>
                    
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="4" >
                    <label for="aulas" class="pl-3 mr-1">Aulas</label>
                    <vs-select id="aulas" filter placeholder="Aulas" v-model="aula" :disabled="!listAulas.length" :key="aulaId" class="pt-0">
                        <template #message-danger v-if="errorFields.includes('aula')">
                            Requerido
                        </template>
                        <template v-if="listAulas.length">
                            <vs-option v-for="option in listAulas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>                 

                    <label for="horaInicio" class="pl-3 mr-1">Hora inicio</label>
                    <vs-input  type="time" id="horaInicio"
                        v-model="horaInicio"
                        placeholder="Hora inicio" class="pt-0">
                    </vs-input>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="4" >
                    <label for="docente" class="pl-3 mr-1">Docente</label>
                     <vs-select id="docente" filter placeholder="Docente" v-model="docente" :disabled="!listDocentes.length" class="pt-0">
                        <template #message-danger v-if="errorFields.includes('docente')">
                            Requerido
                        </template>
                        <template v-if="listDocentes.length">
                            <vs-option v-for="option in listDocentes" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>

                    <label for="horaFIn" class="pl-3 mr-1">Hora Fin</label>
                    <vs-input  type="time" id="horaFin" class="pt-0"
                        v-model="horaFin"
                        placeholder="Hora Fin" 
                    >
                    <template #message-danger v-if="errorFields.includes('horaFin')">
                        Requerido
                    </template>
                    <template v-else-if="errorTime" #message-danger >
                        {{errorTime}}
                    </template>
                       
                    </vs-input>
                   
                </vs-col>
            </vs-row>
            <vs-row >
                <!-- <div class="center con-selects" > -->
                    <label for="dias" class="pl-3 mr-1">Dias</label>
                    <vs-select id="dias" filter multiple placeholder="Dias" v-model="dias" :disabled="!listDias.length" class="pt-0">
                        <!-- <template #message-danger v-if="errorFields.includes('dias')">
                            Requerido
                        </template> -->

                        <vs-option v-for="option in listDias" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                <!-- </div> -->
             </vs-row>
        </div>
        <template #footer>
            <div class="footer-dialog">
                <vs-button center @click="saveform()">
                    Guardar
                </vs-button>

                <div class="new">
                    Dudas? <a href="#">Ve el tutorial de esta sección</a>
                </div>
            </div>
        </template>
    </vs-dialog>
</template>

<script>
import catalogos from '../../../../../api/requests/catalogos.js'
import sesiones from '../../../../../api/requests/sesiones.js'
export default {
    props:[
        'value',
        'institucion',
        'listEdificios',
        'listDocentes',
        'listDias',
        'rowData',
        'crnId'
    ],
    data () {
        return {
            rowId: null,
            edificio: '',
            aula: '',
            docente: '',
            docenteAuxiliar: '', 
            horaInicio: '',
            horaFin: '',
            dias: [],
            listAulas: [],
            active: false,
            aulaId: (new Date()).getTime(),
            errorFields: [],
            errorTime: '',
        }
    },
    methods: {
        async listarAulas () {
            if (this.edificio){
                try {
                    const { data: aulas } = await catalogos.getAulas(this.edificio)
                    this.listAulas = aulas
                    this.aulaId = (new Date()).getTime()
                } catch (error) {
                        
                }
            }else {
                this.listAsignatura = []
            }
        },
        fillForm(row){
            const vm = this
            this.rowId = this.checkByType ('string', row.ids) 
            ? row.ids.split(',') : null
            this.edificio = row.aula instanceof Object 
            && row.aula.edificio_id 
            ? row.aula.edificio_id : ''
            this.aula = row.aula_id || ''
            this.docente = row.docente_en_aula_id || ''
            this.docenteAuxiliar = row.docente_auxiliar_id || ''
            this.horaInicio = row.hora_inicio || ''
            this.horaFin = row.hora_fin || ''
            this.dias = this.checkByType ('string', row.dias)
            ? row.dias.split(',') : []
            this.listarAulas()
        },
        async saveform() {
            try {
                const payload = this.sanityForm()
                if (payload) {
                    const response = await sesiones.updateSesion(payload)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Exito',
                        text: `Registro guardado`
                    })
                    this.$emit('refreshTable',true)
                    this.active = false
                }
            } catch (error) {
                if (error.response.data && error.response.data.errors){
                    const data = error.response.data.errors
                    data.forEach(element => {
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: element
                        })
                    });

                }else{
                    this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                    })
                }
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []

            if (!this.checkByType ('number', this.edificio)) {
                this.errorFields.push('edificio')
            }
            if (!this.checkByType ('number', parseInt(this.aula))) {
                this.errorFields.push('aula')
            }
            if (!this.checkByType ('number', this.docente)) {
                this.errorFields.push('docente')
            }
            if (!this.errorFields.length){
                return {
                    crn_id: this.crnId,
                    hora_inicio: this.horaInicio,
                    hora_fin: this.horaFin,
                    ids: this.rowId,
                    docente_en_aula_id: this.docente,
                    docente_auxiliar_id: this.docenteAuxiliar,
                    aula_id: this.aula,
                    dias: this.dias,
                    institucion_id: this.institucion
                }
            } else {
                return null
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        rowData (val) {
            if (val instanceof Object){
                this.fillForm(val)
            }
        },
        horaFin (val){
            if (val <= this.horaInicio){
                this.errorTime = 'Debe ser mayor a la hora de inicio'
            }else{
                this.errorTime = ''
            }
        }
    }
}
</script>